<sk-modal-content [title]="'label.dms.UploadFiles' | translate"
                  [cancelBtnText]="cancelBtnText"
                  (closed)="onCloseModal()">

  <ng-container #scrollBody id="sk-modal-body">
    <iris-file-uploader
      #fileUploader
      [folderId]="folderId"
      [moduleName]="module"
      [accept]="accept"
      [subjects]="subjects"
      (fileUploaded)="onFileSuccessUpload($event)"
    >
      @if (fileUploader.uploader) {
        @if (fileUploader.uploader?.queue.length) {
          <div class="wrapper-upload-list">
            <table class="table">
              <thead>
              <tr>
                <th></th>
                <th>{{ 'label.Title' | translate }}</th>
                @if (fileUploader.uploader?.options?.isHTML5) {
                  <th>{{ 'label.Size' | translate }}</th>
                  <th>{{ 'label.Progress' | translate }}</th>
                }
                <th>{{ 'label.Status' | translate }}</th>
                <th>{{ 'label.Actions' | translate }}</th>
              </tr>
              </thead>
              <tbody>
                @for (item of fileUploader.uploader?.queue; track item.file.name) {
                <tr>
                  <td>{{ $index + 1 }}</td>
                  <td><strong>{{ item.file?.name }}</strong></td>
                  @if (fileUploader.uploader?.options?.isHTML5) {
                    <td nowrap>{{ item.file?.size | filesize }}</td>
                    <td>
                      <div class="progress">
                        <div class="progress-bar" role="progressbar" [style.width]="item.progress + '%'"></div>
                      </div>
                    </td>
                  }
                  <td class="text-center">
                    <span>
                      <i class="fas"
                        [class.fa-check]="item.isSuccess"
                        [class.fa-ban]="item.isCancel"
                        [class.fa-exclamation-triangle]="item.isError"
                      ></i>
                    </span>
                  </td>
                  <td nowrap>
                    <sk-cell [type]="'actions'">
                      <sk-button
                        [appearance]="'icon'"
                        (click)="item.remove()">
                        <i class="far fa-trash-alt icon text-danger"></i>
                      </sk-button>
                      <sk-button
                        [disabled]="!item.isUploading"
                        class="ms-1"
                        (click)="item.cancel()"
                        [label]="'label.CancelUpload' | translate"
                        [appearance]="'outlined'"
                        [color]="'primary'"
                      >
                        <ng-template buttonPrefix>
                          <i class="fa-fw fas fa-times"></i>
                        </ng-template>
                      </sk-button>
                    </sk-cell>
                  </td>
                </tr>
              }
              </tbody>
            </table>
          </div>
        }

        <div class="text-end mb-2">
          @if (fileUploader.uploader?.getNotUploadedItems().length) {
            <sk-button
              [color]="'primary'"
              [label]="'label.Upload' | translate"
              type="button"
              (click)="fileUploader.uploader.uploadAll()"
            >
              <ng-template buttonPrefix>
                <span class="fa-fw fa fa-upload"></span>
              </ng-template>
            </sk-button>
          }
        </div>
      }
    </iris-file-uploader>

    @if (!isUploadOnly) {
      <p class="sk-alert sk-alert-warning" [hidden]="moduleFiles().length">{{ 'text.NoFilesPleaseUploadFirst' | translate }}</p>

      <div class="flex-grid dms-image-selector">
        @for (file of moduleFiles(); track file.id) {
          <figure
            class="img-thumbnail"
            [class.selected]="selected_file()?.id === file.id"
          >
            <a href="javascript:void(0)" (click)="selectFile(file)">
              @if (isImage(file)) {
                <img [src]="getFileContent(file.id)" alt="">
              }
              @else {
                <div class="view-pdf">
                  <i class="far fa-file" [ngClass]="getFileIcon(file.mimeType)"></i>
                </div>
              }
              @if (isPic(file) && (selected_file()?.id === file.id)) {
                <div
                  (click)="showCrop()"
                  clickStopPropagation
                  class="crop-button"
                >
                  <i class="fas fa-crop"></i>
                </div>
              }
            </a>
            <figcaption class="figure-caption">
              <p>{{ file.name }}</p>
            </figcaption>
          </figure>
        }
      </div>

      @if (cropFieldActive && selected_file()) {
        <div class="crop-area">
          <img-cropper
            #cropper
            class="full-width"
            [image]="data"
            [settings]="cropperSettings"
            (dblclick)="uploadCroppedPicture(fileUploader.uploader)"></img-cropper>
        </div>
      }
    }
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    @if (!isUploadOnly) {
      <sk-button
        [color]="'primary'"
        class="select-button"
        data-test="modal-footer-confirm-button"
        [disabled]="!selected_file()"
        [label]="'label.Select'  | translate"
        (click)="selectFileOrPic(fileUploader.uploader)"
      >
        <ng-template buttonPrefix>
          <i class="fas fa-check"></i>
        </ng-template>
      </sk-button>
    }
  </ng-container>
</sk-modal-content>
